import MagnifierIcon from './component'

export default MagnifierIcon
